/* eslint-disable prefer-template */
import React from 'react';
import PropTypes from 'prop-types';
import './CheckboxFilter.scss';

const toggleFilter = (type) => {
    const parentElement = document.getElementById(`filterDropdown-${type}`);
    if(parentElement.className.includes('closed')) {
        parentElement.className = 'sideBar__search--dropdown';
    } else {
        parentElement.className = 'sideBar__search--dropdown closed';
    }
}

const CheckboxFilter = ({options, selected, type, handleChange, name}) => (
        <div className={`sideBar__search--dropdown ${selected.length > 0 ? '' : 'closed'}`} id={`filterDropdown-${type}`}>
            <button className="sideBar__search--dropdownButton" onClick={() => toggleFilter(type)}>
                <span>{name}</span>
                <span className="fas fa-chevron-down"/>
            </button>

            <div className="sideBar__search--dropdownItems">
                {options.map(option => (
                    <div key={option} className="sideBar__search--dropdownItem">
                        <input 
                            className="sideBar__search--dropdownInput"
                            type="checkbox"
                            checked={selected.includes(option)}
                            id={`dropdownOption--${option}`} 
                            name={option} 
                            value={option} 
                            onClick={(e) => {
                                if(e.target.checked) {
                                    handleChange(option, `${type}Filter`)
                                } else {                                
                                    handleChange(option, `${type}Filter`, true)
                                }
                            }}
                        />
                        <label htmlFor={`dropdownOption--${option}`}>{option}</label>
                    </div>
                ))}
            </div>
        </div>
);


CheckboxFilter.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    options: PropTypes.array.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    selected: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired
};

CheckboxFilter.defaultProps = {
    selected: []
};

export default CheckboxFilter;



// WEBPACK FOOTER //
// ./frontend/components/Jobs/CheckboxFilter.jsx